import LeagueSeasonGameIndex from './LeagueSeasonGameIndex';
import LeagueSeasonGameCreate from './LeagueSeasonGameCreate';
import LeagueSeasonGameSettings from './LeagueSeasonGameSettings';
import LeagueSeasonGameSingle from './LeagueSeasonGameSingle';

export default function (app) {

    const settings = LeagueSeasonGameSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    LeagueSeasonGameIndex(app, settings);

    LeagueSeasonGameCreate(app, settings);

    LeagueSeasonGameSingle(app, settings);

}